export default {
  login: {
    tagline: '先進 3D 網格生成 • 品質導向 • 網頁最佳化',
    agreePrefix: '登入即表示您同意我們的',
    termsOfService: '服務條款',
    and: '與',
    privacyPolicy: '隱私權政策',
    copyright: '版權所有。',
  },
  resetPassword: {
    invalidLinkTitle: '重設連結無效',
    invalidLinkBody: '此密碼重設連結無效或已過期。',
    backToLogin: '返回登入',
    subtitle: '重設您的密碼',
    copyright: '版權所有。',
  },
  oauthConsent: {
    title: '{{clientName}} 想要使用您的 Khorium 帳戶',
    intro: '如果您允許，{{clientName}} 將可以:',
    scopes: {
      openid: '確認您的身分',
      email: '查看您的電子郵件地址',
      profile: '查看您的姓名和個人頭像',
    },
    notGranted: '以下項目不會獲得授權：{{scopes}}',
    allow: '允許',
    deny: '拒絕',
    unknownApp: '此應用程式',
    loading: '正在確認請求…',
    redirecting: '正在返回應用程式…',
    done: '您可以關閉此分頁並返回應用程式。',
    errorTitle: '無法連接應用程式',
    errorBody: '請返回應用程式，重新開始連接。',
  },
  verifyEmail: {
    nudgeManaged: '您的組織正在處理電子郵件驗證。您仍可繼續使用應用程式。',
  },
  appShell: {
    errorFallback: '發生非預期的錯誤。',
    errorTitle: '發生錯誤',
    goToDashboard: '前往儀表板',
  },
} as const;
